import React from 'react';

function Footer() {
  return (
    <footer className='footer'>
      <ul className='unorderedList'>
        <li><a href="https://github.com/shababrc" target="_blank" rel="noopener noreferrer">GitHub</a></li>
        <li><a href="https://www.linkedin.com/in/shabab-rob-chowdhury-0b697318a" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
        {/* Add more links */}
      </ul>
    </footer>
  );
}

export default Footer;
